import { styled } from '@mui/system';
import { Box, Typography } from '@mui/material';
import { colors, fontFamilies } from '../../../../../constants/theme';
import { figmaLetterSpacing } from '../../../../../ui/utils';
import { SectionHeading } from '../../../Splash/styles';
export const BooksIntroSectionContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  maxWidth: '1150px',
  borderRadius: '40px',
}));
export const BooksIntroSectionWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  maxWidth: '1150px',
  boxShadow: `
  -4px -4px 17.8px 0px rgba(205, 214, 223, 0.15),
   4px  4px 15px   0px rgba(205, 214, 223, 0.25)
`,
  borderRadius: '40px',
  padding: '80px 110px',
  [theme.breakpoints.down('md')]: {
    padding: '48px 40px 30px',
  },
}));

export const SectionTitle = styled(SectionHeading)(({ theme }) => ({
  ...theme.typography.heading,
  whiteSpace: 'pre-line',
  textAlign: 'center',
  fontFamily: fontFamilies.gotham,
  fontWeight: 325,
  fontSize: '42px',
  lineHeight: '50.4px',
  letterSpacing: '-0.84px',
  maxWidth: '800px',
  margin: '0 auto',

  [theme.breakpoints.down('md')]: {
    fontSize: 36,
    letterSpacing: figmaLetterSpacing(36, -1),
    lineHeight: '42px',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: 28,
    letterSpacing: figmaLetterSpacing(28, -1),
    lineHeight: '34px',
  },
}));

export const SectionDescription = styled(Typography)(({ theme }) => ({
  ...theme.typography.body1,
  textAlign: 'left',
  fontFamily: fontFamilies.quicksand,
  fontWeight: 400,
  fontSize: 18,
  lineHeight: '32.4px',
  whiteSpace: 'pre-line',
  maxWidth: '822px',
  margin: '0 auto',
  [theme.breakpoints.down('md')]: {
    fontSize: 16,
    lineHeight: '28px',
  },
}));

export const sectionContentStyles = ({ theme }) => ({
  maxWidth: '930px',
  width: '100%',
  margin: '0 auto',
  [theme.breakpoints.up('lg')]: {
    width: '930px',
  },
});

export const SectionContentHeader = styled(Typography)(({ theme }) => ({
  fontFamily: fontFamilies.quicksand,
  fontWeight: 500,
  fontSize: '20px',
  lineHeight: '30px',
  letterSpacing: '-0.2px',
  textAlign: 'center',
}));

export const AdditionalDescription = styled(Typography)(({ theme }) => ({
  fontFamily: fontFamilies.quicksand,
  fontWeight: 400,
  fontSize: '17px',
  lineHeight: '28.9px',
  letterSpacing: '0px',
  textAlign: 'center',
  whiteSpace: 'pre-line',
  maxWidth: '640px',
  margin: '0 auto',
  [theme.breakpoints.down('md')]: {
    fontSize: 16,
  },
}));

export const SectionButtonContainer = styled(Box)(({ theme }) => ({
  margin: '0 auto',
}));

export const BookCardContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  maxWidth: '1150px',
  boxShadow: `
  -4px -4px 17.8px 0px rgba(205, 214, 223, 0.15),
   4px  4px 15px   0px rgba(205, 214, 223, 0.25)
`,
  borderRadius: '40px',
  padding: '10px',
  [theme.breakpoints.down('md')]: {
    padding: '10px 30px',
  },
}));

export const BookCardContent = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isEven',
})(({ theme, isEven }) => ({
  display: 'flex',
  alignItems: 'center',
  flexDirection: isEven ? 'row' : 'row-reverse',
  textAlign: 'left',
  gap: '90px',
  [theme.breakpoints.down('lg')]: {
    gap: '40px',
  },
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    textAlign: 'center',
  },
}));

export const BookImage = styled('img')(({ theme, maxWidth }) => ({
  width: '100%',
  maxWidth: maxWidth || '352px',
  height: '530px',
  objectFit: 'cover',
  display: 'block',
  borderRadius: '30px',
  cursor: 'pointer',
  transition: 'transform 0.3s ease, box-shadow 0.3s ease',
  '&:hover': {
    transform: 'scale(1.01)',
    boxShadow: '0 8px 24px rgba(0,0,0,0.1)',
  },
  [theme.breakpoints.down('md')]: {
    maxWidth: '220px',
    height: 'auto',
  },
}));

export const BookContentWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isEven',
})(({ theme, isEven }) => ({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  gap: '20px',
  marginRight: isEven ? '80px' : '0',
  marginLeft: isEven ? '0' : '80px',
  [theme.breakpoints.down('lg')]: {
    marginRight: isEven ? '40px' : '0',
    marginLeft: isEven ? '0' : '40px',
  },
  [theme.breakpoints.down('md')]: {
    marginRight: '0',
    marginLeft: '0',
  },
}));

export const BookTitle = styled(Typography)(({ theme }) => ({
  fontFamily: fontFamilies.gotham,
  lineHeight: '38px',
  fontWeight: 500,
  fontSize: '32px',
  textTransform: 'capitalize',
  letterSpacing: '.4px',

  [theme.breakpoints.down('lg')]: {
    fontSize: '25px',
    lineHeight: '30px',
    letterSpacing: '0.3px',
  },

  [theme.breakpoints.down('md')]: {
    fontSize: '20px',
    lineHeight: '28px',
    textAlign: 'center',
  },
}));

export const BookDescription = styled(Typography)(({ theme }) => ({
  fontFamily: fontFamilies.quicksand,
  fontWeight: 400,
  fontSize: '18px',
  lineHeight: '28px',
  letterSpacing: figmaLetterSpacing(18, 0),

  [theme.breakpoints.down('lg')]: {
    fontSize: '15px',
    lineHeight: '25.5px',
  },
}));

export const BookLinkButton = styled('a')(({ theme }) => ({
  fontFamily: fontFamilies.gotham,
  fontWeight: 500,
  fontSize: '18px',
  letterSpacing: '0.4px',
  lineHeight: '100%',
  textDecoration: 'underline',
  textDecorationStyle: 'solid',
  textDecorationOffset: '0%',
  textDecorationThickness: '0%',
  textDecorationSkipInk: 'auto',
  color: colors.calmBlue,
  transition: 'all 0.2s',
  '&:hover': {
    color: '#357ABD',
  },
  [theme.breakpoints.down('lg')]: {
    fontSize: '15px',
    lineHeight: '24px',
    letterSpacing: '0.3px',
  },
}));
